import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { MARKET_PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { MpApprovalPage } from '@/features/marketPromotion/pages/MpApprovalPage';
import { mpApprovalSearchSchema } from '@/features/marketPromotion/types/marketPromotion.types';

export const Route = createFileRoute('/_auth/market-promotion/approvals/')({
  beforeLoad: () => requirePermission(MARKET_PROMOTION_PERMISSIONS.APPROVAL_VIEW),
  validateSearch: mpApprovalSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Market Promotion Approval">
      <Suspense fallback={<PageLoader />}>
        <MpApprovalPage routeId="approvals" title="Market Promotion Approval" showCall={false} />
      </Suspense>
    </ErrorBoundary>
  ),
});
